export { LeagueDetailView } from './LeagueDetailView'
export type { LeagueDetailViewProps } from './LeagueDetailView'
